import VariablePlanResource from "./variablePlan.resource";

const variablePlanModule = angular
  .module("app.resources.variablePlan", [])
  .service("VariablePlan", VariablePlanResource);

export default variablePlanModule;



// WEBPACK FOOTER //
// ./src/resources/variablePlan/variablePlan.module.js